import Vue from 'vue'
import VueRouter from 'vue-router'
import { switchLang, defaultLanguage } from '@/i18n'
import footballRoute from './footBallRoute'
import basketballRoute from './basketBallRoute'

Vue.use(VueRouter)

export var routerHistory = []
export var sportID = 1
export var isIOS = false
export var currentLanguage = defaultLanguage
export var currentToken = ''
export var currentApptype = '3'
export var currentApiversion = ''
/*
'lan': query.lan ? query.lan : currentLanguage,
    'token': query.token ? query.token : '',
    'ballType': query.ballType ? query.ballType : sportID,
    'plat': '3', // webapp
    'app_type': query.apptype ? query.apptype : '',
    'apiversion': query.ver ? query.ver : ''
*/

var routes = [
  {
    path: '*',
    name: '404',
    component: () => import('@/views/NotFound')
  },
  {
    path: '/privateProtocol',
    name: 'PrivateProtocol',
    component: () => import('@/views/PrivateProtocol')
  },
  {
    path: '/userRegistProtocol',
    name: 'UserRegistProtocol',
    component: () => import('@/views/UserRegistProtocol')
  }
]
routes = routes.concat(footballRoute)
routes = routes.concat(basketballRoute)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let sportIDRegex = /sport\/(\d)/.exec(to.path)
  if (sportIDRegex && sportIDRegex.length > 1) {
    sportID = sportIDRegex[1]
  }

  let lang = to.query['lan'] ? to.query['lan'] : currentLanguage
  if (lang) {
    switchLang(sportID, lang)
    currentLanguage = lang
  }

  let token = to.query['token'] ? to.query['token'] : currentToken
  if (token) {
    currentToken = token
  }

  let apptype = to.query['apptype'] ? to.query['apptype'] : currentApptype
  if (apptype) {
    currentApptype = apptype
  }

  let ver = to.query['ver'] ? to.query['ver'] : currentApiversion
  if (ver) {
    currentApiversion = ver
  }

  isIOS = to.query['isapp'] ? to.query['isapp'] === '2' : isIOS

  next()
})

function paramsToJsonString (params) {
  let ids = Object.keys(params).filter(item => item.endsWith('Id'))

  var filtedParams = {}
  ids.forEach(item => {
    filtedParams[item] = params[item]
  })

  return JSON.stringify(filtedParams, Object.keys(filtedParams).sort())
}

router.afterEach((to, from) => {
  if (paramsToJsonString(to.params) === paramsToJsonString(from.params)) {
    routerHistory.pop()
  }

  routerHistory.push(to)
})

function exitApp () {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isiOS) { // iOS
    let jsonprc = {
      jsonrpc: 2.0,
      method: 'exit'
    }
    window.webkit.messageHandlers.nativeCallBack.postMessage(jsonprc)
    console.log(jsonprc)
  } else { // Android
    window.JsPhone.goBack()
  }

  console.log('exit app')
}

export function goLastModule () {
  if (routerHistory.length === 1) { // current route
    exitApp()
  }

  routerHistory.pop()

  let lastRoute = routerHistory.pop() // previous route
  router.push({
    name: lastRoute.name ? lastRoute.name : '',
    query: lastRoute.query,
    params: lastRoute.params
  })
}

export default router
